DJ.addBehavior('js-home-slider', '.js-home-slider', {
  attach: function(context, settings, behavior) {
    jQuery.fn.focusWithoutScrolling = function(){
      var x = window.scrollX, y = window.scrollY
      this[0].focus({preventScroll: true})
      window.scrollTo(x, y);
      return this;
    };
    var slickSlider  = jQuery(this);

    // Fonction utilitaire : renvoie le premier CTA (.btn) d'une slide donnée
    function getSlideCta($slider, slideIndex) {
      var $slide = $slider.find('.slick-slide[data-slick-index="' + slideIndex + '"]');
      if (!$slide.length) {
        return null;
      }
      var $cta = $slide.find('.btn').first();
      return $cta.length ? $cta : null;
    }

    // Empêcher les flèches et puces d'entrer dans l'ordre de tabulation
    function makeNavControlsUntabbable($slider) {
      $slider.find('.slick-prev, .slick-next, .slick-dots button')
        .attr('tabindex', '-1');
    }

    // Met à jour les tabindex des CTA : seul celui de la slide courante est tabbable
    function updateCtasTabindex($slider, currentIndex, slick) {
      var $allCtas = $slider.find('.slick-slide .btn');
      $allCtas.attr('tabindex', '-1');

      var $currentCta = getSlideCta($slider, currentIndex);
      if ($currentCta) {
        $currentCta.attr('tabindex', '0');
      }
    }

    // Au changement de slide, positionner le focus sur le CTA de la slide courante
    function focusCurrentSlideCta($slider, currentIndex, slick) {
      var $currentCta = getSlideCta($slider, currentIndex);
      if ($currentCta) {
        updateCtasTabindex($slider, currentIndex, slick);
        $currentCta.focusWithoutScrolling();
      }
    }

    slickSlider.on('init', function(event, slick) {
      var currentIndex = slick.currentSlide || 0;

      // Rendre les contrôles de navigation non tabulables
      makeNavControlsUntabbable(slickSlider);

      // Initialiser les tabindex des CTA et focus sur le CTA de la première slide
      focusCurrentSlideCta(slickSlider, currentIndex, slick);
    });

    slickSlider.on('afterChange', function(event, slick, currentSlide) {
      // À chaque changement, garder les nav hors tab et focus sur le CTA de la slide active
      makeNavControlsUntabbable(slickSlider);
      focusCurrentSlideCta(slickSlider, currentSlide, slick);
    });

    // Gestion de la tabulation entre les slides :
    // Tab depuis le CTA de la slide N -> va au CTA de la slide N+1 (si existe)
    slickSlider.on('keydown', '.slick-slide .btn', function(e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) {
        return;
      }

      var $btn = jQuery(this);
      var $slide = $btn.closest('.slick-slide');
      var slideIndex = $slide.data('slick-index');
      var slick = slickSlider.slick('getSlick');

      // Tabulation vers l'avant uniquement
      if (!e.shiftKey) {
        // Si ce n'est pas la dernière slide, on intercepte pour aller à la slide suivante
        if (slideIndex < slick.slideCount - 1) {
          e.preventDefault();
          slickSlider.slick('slickGoTo', slideIndex + 1);
          // Le focus sera placé sur le CTA de la slide suivante dans afterChange
        }
        // Sinon (dernière slide), on laisse le comportement natif pour sortir du slider
      }
      // Pour Shift+Tab, on laisse le comportement natif (retour aux éléments précédents)
    });

    slickSlider.slick({
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      prevArrow: '<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Précédent</span></button>',
      nextArrow: '<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Suivant</span></button>',
      customPaging: function(slider, i) {
        return '<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Aller à la diapositive ' + (i + 1) + '</span></button>';
      },
    });
  },

  detach: function(context, settings) {}
});
